import http from './index';

export const httpGetBedrooms = () => {
  const url = '/listings/bedrooms/';

  return http.get(url);
};

export const httpGetBathrooms = () => {
  const url = '/listings/bathrooms/';

  return http.get(url);
};
